import { Texture } from "three"

export default function createCenteredTextTexture(
  text: string,
  padding: number = 20
) {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')!

  // Set font first for accurate measurement
  const fontSize = 64
  const font = `bold ${fontSize}px sans-serif`
  context.font = font

  // Measure text dimensions
  const metrics = context.measureText(text)
  const textWidth = metrics.width
  const textHeight = fontSize // approximate height based on font size

  // Set canvas size based on text + padding
  const canvasWidth = Math.ceil(textWidth + padding * 2)
  const canvasHeight = Math.ceil(textHeight + padding * 2)
  canvas.width = canvasWidth
  canvas.height = canvasHeight

  // Reset font after resizing canvas (important!)
  context.font = font
  context.fillStyle = 'rgba(0,0,0,0.6)'
  context.fillRect(0, 0, canvas.width, canvas.height)
  context.fillStyle = '#bbb'
  context.textAlign = 'center'
  context.textBaseline = 'middle'

  // Draw text centered
  context.fillText(text, canvas.width / 2, canvas.height / 2)

  const texture = new Texture(canvas)
  texture.needsUpdate = true
  return texture
}